'use strict';

var $Object = require('es-object-atoms');

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;



//////////////////
// WEBPACK FOOTER
// ./~/_get-proto@1.0.1@get-proto/Object.getPrototypeOf.js
// module id = Lf9+
// module chunks = 0